import { messages, intl } from '../messages';
import { actions as emrFacilityMappingsActions } from 'src/redux/data/emrMappings';

export const emrFacilityMappingsErrorNotificationMessagesMap = {
  [emrFacilityMappingsActions.getFacilities.type]: (_, err) => ({
    message: intl.formatMessage(messages.getFacilitiesError),
    description: err || '',
  }),
  [emrFacilityMappingsActions.syncFacility.type]: () => ({
    message: intl.formatMessage(messages.syncFacilityError),
  }),
  [emrFacilityMappingsActions.mapFacilities.type]: (_, err) => ({
    message: intl.formatMessage(messages.mappingFacilitiesError),
    description: err || '',
  }),
  [emrFacilityMappingsActions.onboardFacility.type]: (_, err) => ({
    message: intl.formatMessage(messages.onboardFacilityError),
    description: err || '',
  }),
  [emrFacilityMappingsActions.onboardPatients.type]: (_, err) => ({
    message: intl.formatMessage(messages.onboardPatientsError),
    description: err || '',
  }),
};

export const emrFacilityMappingsSuccessNotificationMessagesMap = {
  [emrFacilityMappingsActions.syncFacility.type]: () => ({
    message: intl.formatMessage(messages.syncFacilitySuccess),
  }),
  [emrFacilityMappingsActions.mapFacilities.type]: () => ({
    message: intl.formatMessage(messages.mappingFacilitiesSuccess),
  }),
  [emrFacilityMappingsActions.onboardFacility.type]: () => ({
    message: intl.formatMessage(messages.onboardFacilitySuccess),
  }),
  [emrFacilityMappingsActions.onboardPatients.type]: () => ({
    message: intl.formatMessage(messages.onboardPatientsError),
  }),
};
